import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CopyToMedications } from "models/order-management/copyToMedications";
import {
  OpenSearchResponse,
  Order,
  OrderBulkRequest,
  OrderPatchRequest,
  OrderResponse,
  OrderSearchRequest,
  OrderTypeConfiguration,
} from "models/order-management/models";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";
import { ConfigurationService } from "../configuration/configuration.service";
import { mockConfig } from "./mock-config";
import { getMockSearch } from "./mock-search";

@Injectable()
export class OrderManagementDataService {
  private apiUrl: string;
  private mock: boolean = false;

  constructor(private http: HttpClient, private config: ConfigurationService) {
    this.apiUrl = config.getConfig().apiUrl;

    if (
      this.config.getConfig().isLocal &&
      this.config.getConfig().localEndpoints.orderManagement
    ) {
      this.apiUrl = this.config.getConfig().localEndpoints.orderManagement;
    } else {
      this.apiUrl = this.config.getConfig().apiUrl + "/orders";
    }
  }

  public getOrderTypes(): Observable<Array<OrderTypeConfiguration>> {
    if (this.mock) {
      return of(mockConfig);
    }
    return this.http.get<Array<OrderTypeConfiguration>>(`${this.apiUrl}/types`);
  }

  public bulkUpdateOrders(request: OrderBulkRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/bulk`, request);
  }

  public searchOrders(
    orderSearchRequest: OrderSearchRequest
  ): Observable<OpenSearchResponse> {
    if (this.mock) {
      return of(
        getMockSearch({
          size: orderSearchRequest.size,
        })
      );
    }
    return this.http.post<OpenSearchResponse>(
      `${this.apiUrl}/search`,
      orderSearchRequest
    );
  }

  public updateOrder(
    orderId: string,
    orderPatchRequest: OrderPatchRequest
  ): Observable<OrderResponse> {
    if (this.mock) {
      return of();
    }
    const serializeOrderCreateRequest = this.serialize(orderPatchRequest);
    return this.http.patch<OrderResponse>(
      `${this.apiUrl}/${orderId}`,
      serializeOrderCreateRequest
    );
  }

  public createOrderByPatientChartId(
    patientChartId: number,
    orderCreateRequest: Order
  ): Observable<OrderResponse> {
    if (this.mock) {
      return of({
        patientChartId: patientChartId,
        ...orderCreateRequest,
        orderId: "1234",
      });
    }
    const serializedOrderCreateRequest = this.serialize(orderCreateRequest);
    return this.http.post<OrderResponse>(
      `${this.apiUrl}/patient/${patientChartId}`,
      serializedOrderCreateRequest
    );
  }

  public copyToMedications(payload: CopyToMedications): Observable<void> {
    const serializedObject = this.serialize(payload);
    return this.http.post<void>(
      `${this.apiUrl}/copyToMedications`,
      serializedObject
    );
  }

  // Helpers
  serialize(body: any) {
    // Does set to array conversion
    return JSON.stringify(body, (_key, value) =>
      value instanceof Set ? Array.from(value) : value
    );
  }

  public faxOrders(request: any): Observable<any> {
    return this.http.post<OpenSearchResponse>(`${this.apiUrl}/fax`, request);
  }
}



// WEBPACK FOOTER //
// ./src/providers/order-management-data-service/order-management-data-service.ts